<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :allowFields="$lang.searchCenterExecute"
      :url="url"
      :title="$lang.searchCenter_execute"
      :remove_item="removeItem"
      config="center_execute"
      :toggleable="true"
      :allowRemove="false"
      add-modal-size="lg"
      remove-modal-size="xl"
      ref="search_center_execute"
      :primaryKey="`center_execute_id`"
      :allowEdit="false"
      :filterCatch="true"
      :isLoading="isLoading"
      :dynamicButtons="availableButtons"
      :hiddenFields="hiddenFields"
      :visibleAdd="!isEndedCenterExecute"
    >
      <template slot="addModal" slot-scope="search">
        <AddCenterExecute
          isModal
          @getData="getData"
          @modal-end-up="search.close"
        />
      </template>
    </Search>

    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      hide-header
      content-class="border-primary"
      size="xl"
      v-model="calendarModal"
      :ok-title="$lang.submitButton"
    >
      <DragTable
        :url="center_execute_plan_url"
        :title="$lang.execute_plan"
        :filterCatch="true"
        :emptyText="$lang.notExistParvandehInfoMessage"
        ref="center_execute_plan"
        keyLang="center_execute_plan"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
      />
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="calendarModal = false">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      size="xl"
      v-model="changeAssessmentModal"
      :ok-title="$lang.submitButton"
    >
      <b-card>
        <div slot="header">
          <strong v-text="$lang.changeAssessmentPlan" />
        </div>

        <LoadingSpinner
          :loading="changeAssessmentPlanLoading"
          :text="$lang.sending_data"
        />
        <b-form
          @submit.prevent="changeAssessmentPlan"
          v-show="!changeAssessmentPlanLoading"
        >
          <b-alert show variant="info">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <strong v-text="$lang.changeAssessmentPlanAlert" />
          </b-alert>
          <div class="mb-3">
            <strong v-text="$lang.template" />:
            <span
              class="text-muted"
              v-text="pathOr('', ['template', 'caption'], currentCenterExecute)"
            />
          </div>
          <div class="mb-3">
            <strong v-text="$lang.old_assessment_plan" />:
            <span
              class="text-muted"
              v-text="
                pathOr('', ['assessment_plan', 'name'], currentCenterExecute)
              "
            />
          </div>
          <b-form-group
            :label="$lang.new_assessment_plan"
            label-for="assessment_plan_id"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.new_assessment_plan"
              :rules="$v.assessment_plan_selected.$params"
            />
            <selectFind
              :options="assessment_plan_options"
              v-model="$v.assessment_plan_selected.$model"
              label="name"
              :isValid="
                $v.assessment_plan_selected.$dirty
                  ? !$v.assessment_plan_selected.$error
                  : null
              "
              :loading="assessment_plan_loading"
            />

            <b-form-invalid-feedback id="assessment_plan-feedback">
              {{
                $lang.error_required | replace($lang.new_assessment_plan)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="mr-2"
              variant="outline-danger"
              @click="closeChangeAssessmentModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button type="submit" variant="success">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </div>
        </b-form>
      </b-card>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      v-model="changeStatusModal"
      size="sm"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="$lang.change_level" />
        </div>
        <LoadingSpinner
          :loading="changeStatusLoading"
          :text="$lang.sending_data"
        />
        <b-row v-show="!changeStatusLoading">
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.level_label}: `"
                :rules="$v.statusSelected.$params"
              />
              <selectFind
                :options="statusOptions"
                v-model="$v.statusSelected.$model"
                label="caption"
                id="id"
                :isValid="
                  $v.statusSelected.$dirty ? !$v.statusSelected.$error : null
                "
              />
              <b-form-invalid-feedback
                :state="
                  $v.statusSelected.$dirty ? !$v.statusSelected.$error : null
                "
              >
                <div v-if="!$v.statusSelected.required">
                  {{ $lang.error_required | replace($lang.level_label) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="text-right">
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="closeChangeStatusModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button variant="success" @click="changeStatus">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <Confirm
      :title="modalTitle"
      :description="message"
      v-model="changeModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="ok"
      @cancel="cancel"
    />
    <b-modal
      no-close-on-backdrop
      v-model="startDelayModal"
      size="sm"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="$lang.submit_start_delay" />
        </div>
        <LoadingSpinner
          :loading="startDelayLoading"
          :text="$lang.sending_data"
        />
        <b-row v-show="!startDelayLoading">
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.start_delay} (${$lang.minute}): `"
                :rules="$v.startDelay.$params"
              />
              <b-form-input
                v-model="$v.startDelay.$model"
                type="number"
                autocomplete="off"
                :state="$v.startDelay.$dirty ? !$v.startDelay.$error : null"
              />
              <b-form-invalid-feedback
                :state="$v.startDelay.$dirty ? !$v.startDelay.$error : null"
              >
                <div v-if="!$v.startDelay.required">
                  {{ $lang.error_required | replace($lang.start_delay) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="text-right">
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="closeStartDelayModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button
              :disabled="!startDelay"
              variant="success"
              @click="SubmitStartDelay"
            >
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddCenterExecute from "./addCenter_execute";
import Confirm from "@/components/base/confirm";
import DragTable from "@/components/base/dragTable";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  name: "search-center-execute",
  components: {
    Search,
    AddCenterExecute,
    DragTable,
    Confirm,
    LoadingSpinner,
  },
  validations: {
    assessment_plan_selected: { required },
    statusSelected: { required },
    startDelay: { required },
  },
  data() {
    return {
      hiddenFields: [
        "room_count",
        "case_count",
        "assessor_count",
        "candidate_count",
        "template.id",
        "template.caption",
        "assessment_plan.id",
        "company.caption",
        "created_by",
        "created_at.jalali",
      ],
      changeModal: false,
      isLoading: false,
      calendarModal: false,
      buttons: [
        {
          name: "edit",
          click: this.searchCenterExecute,
          status: [1, 2, 3, 4],
          allowUserExecutiveRoles: [3, null],
        },
        {
          name: "justShow",
          click: this.searchCenterExecute,
          status: [5],
          allowUserExecutiveRoles: [3, null],
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          name: "submitStartDelay",
          text: this.$lang.submit_start_delay,
          iconFont: {
            name: "timer-outline",
            size: "24",
            class: "text-warning",
          },
          status: [1],
          allowUserExecutiveRoles: [3, null],
          AllowPermissions: ["admin", "edit"],
          click: this.showStartDelayModal,
        },
        {
          name: "changeStatus",
          click: this.showChangeStatusModal,
          text: this.$lang.change_level,
          allowUserExecutiveRoles: [3, null],
          AllowPermissions: ["admin", "edit"],
        },
        {
          name: "calendar",
          iconFont: "fa fa-list-ol fa-lg text-warning ",
          click: this.centerExecuteCalendar,
          allowUserExecutiveRoles: [2, 3, 4, 5, null],
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          name: "visitCases",
          click: this.searchCase,
          iconFont: "fas fa-folder-open fa-lg text-info ",
          status: [2, 3, 4, 5],
          allowUserExecutiveRoles: [2, 3, 4, 5, null],
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          name: "washup",
          click: this.showWashUp,
          status: [2, 3, 4, 5],
          allowUserExecutiveRoles: [3, 5, 6, 7, null],
          AllowPermissions: ["admin", "edit", "view"],
        },
        {
          name: "excelExport",
          click: this.export_excel,
          status: [5, 6],
          allowUserExecutiveRoles: [3, null],
        },
        {
          name: "changeAssessment",
          click: this.showChangeAssessmentModal,
          status: [1],
          allowUserExecutiveRoles: [3, null],
          AllowPermissions: ["admin"],
        },
        {
          name: "delete",
          iconFont: {
            name: "close",
            size: "25",
            class: "text-danger",
          },
          click: this.removeItem,
          status: [1],
          allowUserExecutiveRoles: [3, null],
          AllowPermissions: ["admin"],
        },
      ],
      mode: "",
      modalTitle: "",
      message: "",
      changingItems: null,
      removingItem: null,
      changeAssessmentModal: false,
      currentCenterExecute: null,
      assessment_plan_options: [],
      assessment_plan_selected: null,
      assessment_plan_loading: false,
      changeAssessmentPlanLoading: false,
      centerExecuteId: null,
      statusSelected: null,
      changeStatusLoading: false,
      changeStatusModal: false,
      centerExecutePlanId: null,
      centerExecuteCode: null,
      startDelayModal: false,
      startDelayLoading: false,
      startDelay: 0,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "center_execute"]);
    },
    isEndedCenterExecute() {
      return this.$route.name === "ended_center_execute";
    },
    center_execute_plan_url() {
      return generateApiUrl(
        ["kanoon", "center_execute_plan_id"],
        [this.centerExecutePlanId]
      );
    },
    statusOptions() {
      return renderEumOptions("center_execute_status").map((item) => {
        return {
          caption: pathOr("", ["text"], item),
          id: pathOr("", ["value"], item),
        };
      });
    },
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    renderEumOptions,
    getData() {
      this.$refs.search_center_execute.getItems();
    },
    centerExecuteCalendar(item) {
      this.centerExecutePlanId = pathOr(null, ["center_execute_id"], item);
      this.calendarModal = true;
    },
    reports(item) {
      this.$router.push({
        name: "reportPage",
        params: {
          id: item.center_execute_id,
        },
      });
    },
    clearModal() {
      this.mode = "";
      this.changeModal = false;
      this.modalTitle = "";
    },
    ok() {
      if (this.mode == "change_status") {
        this.confirmedChangeStatus();
      } else if (this.mode == "remove_item") {
        this.confirmedRemoveItem();
      }
      this.clearModal();
    },
    cancel() {
      if (this.mode == "change_status") {
        this.notConfirmedChangeStatus();
      } else if (this.mode == "remove_item") {
        this.notConfirmedRemoveItem();
      }
      this.clearModal();
    },
    availableButtons(item) {
      if (!item || !("status_object" in item)) return [];
      return this.buttons.filter((x) => {
        const userExecutiveRoleId = pathOr(
          null,
          ["user_executive_role", "id"],
          item
        );
        const allowUserExecutiveRoles = pathOr(
          [],
          ["allowUserExecutiveRoles"],
          x
        );
        const allowStatusArr = pathOr([], ["status"], x);
        const rowStatusId = pathOr(null, ["status", "id"], item);
        let con = true;
        if (allowStatusArr.length) {
          con = includes(rowStatusId, allowStatusArr);
        }

        // اگر نقش کانونی داشت شرط نقش کانونی هم اعمال شود
        if (allowUserExecutiveRoles.length) {
          con = con && includes(userExecutiveRoleId, allowUserExecutiveRoles);
        }
        return con;
      });
    },
    /* endCenter(item) {
      this.changeStatus(item, 4);
    }, */
    executing(item) {
      this.changeStatus(item, 3);
    },
    /* returnToEditing(item) {
      this.changeStatus(item, 1);
    }, */
    /* creatingCase(item) {
      this.changeStatus(item, 2);
    }, */
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    searchCenterExecute(item) {
      this.$router.push("/ac/center_execute/edit/" + item.center_execute_id);
    },
    searchCase(item) {
      this.$router.push(
        "/ac/center_execute/" + item.center_execute_id + "/case/search"
      );
    },
    showWashUp(item) {
      this.$router.push(
        "/ac/center_execute/" + item.center_execute_id + "/washup/search"
      );
    },
    editItem(item) {},
    confirmedRemoveItem() {
      if (this.removingItem) {
        this.isLoading = true;
        return this.$httpService
          .delete(this.url + "/" + this.removingItem.center_execute_id)
          .then((response) => {
            this.$notify.success(response.data.message);
            return true;
          })
          .catch((err) => {
            this.$notify.error(err.response.data.message);
            throw "error";
          })
          .finally(() => {
            this.isLoading = false;
            this.removingItem = null;
            this.message = "";
            this.$refs.search_center_execute.getItems();
          });
      }
    },
    notConfirmedRemoveItem() {
      this.removingItem = null;
      this.message = "";
    },
    removeItem(item) {
      this.removingItem = item;
      this.mode = "remove_item";
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.remove_item;
      this.changeModal = true;
    },
    toggle_item(item) {},
    confirmedChangeStatus() {
      if (this.changingItems != null && this.status != null) {
        this.isLoading = true;
        let payLoad = {
          status: this.status,
        };
        this.isLoading = true;
        return this.$httpService
          .patch(
            this.$config.api_url +
              this.$config.kanoon.center_execute +
              "/" +
              this.changingItems.center_execute_id +
              "/state",
            payLoad
          )
          .then((response) => {
            this.$notify.success(response.data.message);
            this.$refs.search_center_execute.getItems();
            return true;
          })
          .catch((error) => {
            this.$generateError(error);
          })
          .finally(() => {
            this.isLoading = false;
            this.changingItems = null;
            this.status = null;
            this.message = "";
            this.$refs.search_center_execute.getItems();
          });
      }
    },
    notConfirmedChangeStatus() {
      this.changingItems = null;
      this.status = null;
      this.message = "";
    },
    /* changeStatus(item, status) {
      this.mode = "change_status";
      this.changingItems = item;
      this.status = status;
      this.modalTitle = this.$lang.change_status;
      this.message = this.$lang.are_you_sure;
      if (status === 2) {
        this.message = `${this.$lang.you_will_create_cases} ${this.$lang.are_you_sure}`;
      }
      if (status === 4) {
        this.modalTitle = this.$lang.end_ac;
        this.message = `${this.$lang.end_ac_message} ${this.$lang.are_you_sure_end_ac}`;
      }
      this.changeModal = true;
    }, */
    async export_excel(item) {
      try {
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_export"],
          [item.center_execute_id]
        );
        const response = await this.$httpService.get(url);
        const fileURL = response.data.data;
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;

        fileLink.setAttribute("download", "");
        fileLink.click();
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    showChangeAssessmentModal(item) {
      this.currentCenterExecute = item;
      const template = pathOr(null, ["template"], item);
      this.getAssessmentPlan(template);
      this.changeAssessmentModal = true;
    },
    closeChangeAssessmentModal() {
      this.currentCenterExecute = null;
      this.changeAssessmentModal = false;
    },
    async getAssessmentPlan(template) {
      try {
        this.assessment_plan_selected = null;
        this.assessment_plan_options = [];
        this.$v.$reset();

        this.assessment_plan_loading = true;
        const template_id = pathOr(null, ["id"], template);
        const url = generateApiUrl(["kanoon", "assessment_plan_combo"], [], {
          template_id,
          has_plan: true,
        });
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        const oldAssessmentPlanId = pathOr(
          null,
          ["assessment_plan", "id"],
          this.currentCenterExecute
        );
        this.assessment_plan_options = data.filter(
          (item) => item.id !== oldAssessmentPlanId
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.assessment_plan_loading = false;
      }
    },
    async changeAssessmentPlan() {
      this.$v.$touch();
      if (this.$v.assessment_plan_selected.$anyError) return;

      try {
        this.changeAssessmentPlanLoading = true;
        const code = pathOr(
          null,
          ["center_execute_code"],
          this.currentCenterExecute
        );
        const url = generateApiUrl(
          ["kanoon", "center_execute_assessment_plan"],
          [code]
        );
        const payload = {
          assessment_plan_id: pathOr(
            null,
            ["id"],
            this.assessment_plan_selected
          ),
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.getData();
        this.closeChangeAssessmentModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeAssessmentPlanLoading = false;
      }
    },
    showChangeStatusModal(item) {
      this.centerExecuteId = pathOr(null, ["center_execute_id"], item);
      this.statusSelected = pathOr(null, ["status"], item);
      this.changeStatusModal = true;
    },
    closeChangeStatusModal() {
      this.centerExecuteId = null;
      this.statusSelected = null;
      this.changeStatusModal = false;
    },
    async changeStatus() {
      try {
        this.changeStatusLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_state"],
          [this.centerExecuteId]
        );
        const payload = {
          status: pathOr(null, ["id"], this.statusSelected),
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeChangeStatusModal();
        this.$refs.search_center_execute.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.changeStatusLoading = false;
      }
    },
    showStartDelayModal(item) {
      this.centerExecuteCode = pathOr(null, ["center_execute_code"], item);
      this.startDelay = pathOr(0, ["start_delay"], item);
      this.startDelayModal = true;
    },
    closeStartDelayModal() {
      this.startDelayModal = false;
    },
    async SubmitStartDelay() {
      try {
        this.startDelayLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_start_delay"],
          [this.centerExecuteCode]
        );
        const payload = { start_delay: this.startDelay };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeStartDelayModal();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.startDelayLoading = false;
      }
    },
  },
};
</script>
